import api from './base'

export default {
  /* return only all sessios per business unit */
  getAll ({ businessUnitId }) {
    return api().get(`company/business_units/${businessUnitId}/table_sessions?type=0`)
  },
  getOpenedSessions ({ businessUnitId }) {
    return api().get(`company/business_units/${businessUnitId}/table_sessions?type=1`)
  },
  getAllBetweenDates ({ businessUnitId, dateFrom, dateTo, dateEndFrom, dateEndTo, type }) {
    let url = `company/business_units/${businessUnitId}/table_sessions?type=${type}`
    if (dateFrom) {
      url += `&dateFrom=${dateFrom}`
    }
    if (dateTo) {
      url += `&dateTo=${dateTo}`
    }
    if (dateEndFrom) {
      url += `&dateEndFrom=${dateEndFrom}`
    }
    if (dateEndTo) {
      url += `&dateEndTo=${dateEndTo}`
    }
    return api().get(url)
    // return api().get(`company/business_units/${businessUnitId}/table_sessions?dateFrom=${dateFrom}&dateTo=${dateTo}&dateEndFrom=${dateEndFrom}&dateEndTo=${dateEndTo}&type=0`)
  },
  endTableSession ({ electronicDeviceId, tableSessionId, item }) {
    return api().put(`company/electronic_devices/${electronicDeviceId}/table_sessions/${tableSessionId}/end`, item)
  }
}
